/**
 * Shared field validators for the RMA return forms (create / invoice /
 * quick-ship / process). Keeps the submit-time and live-entry checks in
 * one place so every form accepts the same shipping-cost input.
 *
 * Contains:
 * - isValidShippingCost — blank or a well-formed dollar amount
 */

import { currencyRegex } from '@sophocles/utils';

export function isValidShippingCost(value) {
  return !value || currencyRegex.test(value);
}
